import { useLanguage } from '../i18n';

const Projects = ({ setActiveSection }) => {
  const { language } = useLanguage();
  const c = language === 'es' ? { title:'Nuestros proyectos', intro:'Juegos hechos por un equipo indie: ideas claras, identidad local y mucho oficio en cada detalle.', desc:'Run & Gun lleno de humor ácido, recorriendo una Argentina caricaturesca.', genre:'Género', platform:'Plataforma', play:'Jugar juego', soon:'Próximamente', development:'En desarrollo.' } : { title:'Our projects', intro:'Games made by an indie team: clear ideas, local identity and careful craft in every detail.', desc:'A run-and-gun packed with sharp humor, set across a caricatured Argentina.', genre:'Genre', platform:'Platform', play:'Play game', soon:'Coming soon', development:'In development.' };
  return (
    <section id="projects" className="section-shell min-h-screen px-4 py-12 sm:py-16 lg:py-20">
      <div className="section-content max-w-7xl mx-auto">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="section-title text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black mb-4 sm:mb-6">
            {c.title}
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-purple-200 max-w-3xl mx-auto px-4">
            {c.intro}
          </p>
        </div>

        <div className="mb-12 sm:mb-16 lg:mb-20">
          <div className="modern-panel rounded-xl overflow-hidden transition-all duration-500">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
              <div className="bg-black/20 flex items-center justify-center p-3 sm:p-4">
                <div className="w-full bg-white/10 rounded-lg flex items-center justify-center backdrop-blur-sm border border-white/15 overflow-hidden aspect-video shadow-inner">
                  <img
                    src="/gallery/Pantalla_Inicio.png"
                    alt="OP CHORI Gameplay"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="p-6 sm:p-8 lg:p-10 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-2.5 h-2.5 bg-green-400 rounded-full animate-pulse"></div>
                  <h3 className="text-2xl sm:text-3xl font-bold text-white">OP CHORI</h3>
                  <img
                    src="/adva-mpvp-selected-v2.png"
                    alt="Seleccionado ADVA MPVP"
                    title="Seleccionado ADVA MPVP"
                    className="ml-auto w-24 sm:w-32 h-auto object-contain drop-shadow-[0_0_10px_rgba(255,215,0,0.18)]"
                  />
                </div>
                <p className="text-purple-200 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
                  {c.desc}
                </p>
                <div className="grid grid-cols-2 gap-3 sm:gap-4 mb-4 sm:mb-6">
                  <div className="bg-black/20 rounded-lg p-3 border border-white/10">
                    <p className="text-purple-300 text-xs sm:text-sm">{c.genre}</p>
                    <p className="text-white font-semibold text-sm sm:text-base">Run and Gun</p>
                  </div>
                  <div className="bg-black/20 rounded-lg p-3 border border-white/10">
                    <p className="text-purple-300 text-xs sm:text-sm">{c.platform}</p>
                    <p className="text-white font-semibold text-sm sm:text-base">Windows</p>
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                  <a
                    href="https://nuclearteam.itch.io/op-chori"
                    target="_blank"
                    rel="noreferrer"
                    className="primary-button w-full sm:w-auto px-4 sm:px-6 py-2 sm:py-3 rounded-full font-semibold text-center transform hover:-translate-y-0.5 transition-all duration-300 text-sm sm:text-base"
                  >
                    {c.play}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-6 sm:mb-8 text-center">{c.soon}</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
            <div className="modern-panel rounded-xl p-4 sm:p-6 transition-all duration-300 transform hover:-translate-y-1">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-2.5 h-2.5 bg-red-400 rounded-full animate-pulse"></div>
                <h4 className="text-lg sm:text-xl font-bold text-white">DeadJavu</h4>
              </div>
              <div className="w-full aspect-video bg-black/20 rounded-lg mb-4 overflow-hidden border border-white/10">
                <img
                  src="/gallery/deadjavu-gameplay.png"
                  alt="DeadJavu gameplay"
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="text-purple-200 mb-4 text-sm sm:text-base">
                {c.development}
              </p>
              <div className="flex flex-wrap gap-2 mb-4">
                <span className="indie-chip px-2 py-1 rounded-full text-xs">Roguelike</span>
                <span className="indie-chip px-2 py-1 rounded-full text-xs">Steampunk</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Projects;
